import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
  createRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

import {
  ExternalRoutesIds as MetricsReactExternalRoutesIds,
  assignmentTableRouteRef,
  assignmentTablesCreateRouteRef,
  entitiesRouteRef,
  entityRouteRef,
  factTableRouteRef,
  factTablesCreateRouteRef,
  metricRouteRef,
  metricsRouteRef,
} from '@spotify/plugin-confidence-metrics-react';

export enum RoutesIds {
  metrics = 'metrics',
  metric = 'metric',
  metricExplorer = 'metricExplorer',
  measurements = 'measurements',
  measurement = 'measurement',
}

enum ExternalRoutesIds {
  workflowInstance = 'workflowInstance',
  events = 'events',
  factTables = 'factTables',
  metricsDataWarehouse = 'metricsDataWarehouse',
  labels = 'labels',
  collections = 'collections',
  collection = 'collection',
}

// root route
export const rootRouteRef = metricsRouteRef;

export const metricExplorerRouteRef = createSubRouteRef({
  id: RoutesIds.metricExplorer,
  path: '/explorer',
  parent: rootRouteRef,
});

// measurements root route (separate from metrics)
export const measurementsRouteRef = createRouteRef({
  id: RoutesIds.measurements,
});

export const measurementRouteRef = createSubRouteRef({
  id: RoutesIds.measurement,
  path: '/:id',
  parent: measurementsRouteRef,
});

// external routes to other plugins
export const workflowInstanceRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.workflowInstance,
  params: ['workflow', 'id'],
  optional: true,
});

export const factTablesRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.factTables,
  optional: true,
});

export const eventsRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.events,
  optional: true,
});

export const metricsDataWarehouseRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.metricsDataWarehouse,
  optional: true,
});

export const labelsRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.labels,
  optional: true,
});

export const collectionsRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.collections,
});

export const collectionRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.collection,
  params: ['id'],
});

export const Routes = {
  metrics: metricsRouteRef,
  metric: metricRouteRef,
  metricExplorer: metricExplorerRouteRef,
  measurements: measurementsRouteRef,
  measurement: measurementRouteRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const ExternalRoutes = {
  // routes to other plugins
  workflowInstance: workflowInstanceRouteRef,
  factTable: factTableRouteRef,
  events: eventsRouteRef,
  factTables: factTablesRouteRef,
  factTablesCreate: factTablesCreateRouteRef,
  entities: entitiesRouteRef,
  entity: entityRouteRef,
  assignmentTable: assignmentTableRouteRef,
  assignmentTablesCreate: assignmentTablesCreateRouteRef,
  metricsDataWarehouse: metricsDataWarehouseRouteRef,
  labels: labelsRouteRef,
  collections: collectionsRouteRef,
  collection: collectionRouteRef,
} satisfies Record<ExternalRoutesIds, ExternalRouteRef> &
  Record<MetricsReactExternalRoutesIds, ExternalRouteRef>;
